import React from 'react';

import { Box } from '@mui/material';

import { createStatusItems } from '../Common/components/Listing/statusConfig';

export const statusItems = createStatusItems({
  allValue: 'ALL',
  awaitingLabel: 'Awaiting Clinic',
  awaitingValue: 'Awaiting Clinic',
  notificationLabel: 'Not Acknowledged',
  notificationValue: 'Not Acknowledged'
});

const getStatusColor = status => {
  switch (status) {
    case 'Awaiting Clinic':
      return '#F44336';

    case 'Not Acknowledged':
      return '#1976D2';

    default:
      return '#2E9D43';
  }
};

export const ptMessageColumns = [
  {
    field: 'patient',
    headerName: 'Patient',
    width: '20%',
    primary: true
  },
  {
    field: 'message',
    headerName: 'Message',
    width: '38%',
    renderCell: value => (
      <Box
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
        {value}
      </Box>
    )
  },
  {
    field: 'from',
    headerName: 'From',
    width: '10%'
  },
  {
    field: 'date',
    headerName: 'Date',
    width: '14%'
  },
  {
    field: 'status',
    headerName: 'Status',
    width: '18%',
    cellSx: value => ({
      color: getStatusColor(value),
      fontWeight: 500
    })
  }
];